export const VideoContainer = ({ url }) => {
  return (
    <div className="productVideos mt-4">
      <iframe
        width="100%"
        height={315}
        src={url}
        title="YouTube video player"
        frameBorder={0}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen=""
      />
    </div>
  );
};
